export default __webpack_public_path__ + "2fb0553c876b7c58b663917759693058.png";